/* Optibio homepage system behaviour.
   Extracted verbatim from sections/cd-rest.liquid on 2026-08-28.
   Loaded with defer by every cd-home-*.liquid section, so it is guarded
   to bind exactly once no matter how many sections are on the page. */
if (!window.__optibioCdrInit) {
  window.__optibioCdrInit = true;
(function(){
  'use strict';

  /* ---- Scroll reveal ---- */
  var revEls = document.querySelectorAll('.cdr-reveal');
  if (revEls.length) {
    var revObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('visible'); revObs.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px 35% 0px' });
    revEls.forEach(function(el){ revObs.observe(el); });
  }

  /* ---- KSM-66 checkmark draw animation ---- */
  var ksmGlass = document.querySelector('.cdr-ksm-glass');
  if (ksmGlass) {
    var ksmObs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); ksmObs.unobserve(e.target); } });
    }, { threshold: 0.15 });
    ksmObs.observe(ksmGlass);
  }

  /* ---- Goal Picker tabs ---- */
  var goalTabs = document.querySelectorAll('.cdr-goal-tab');
  var goalPanels = document.querySelectorAll('.cdr-goal-panel');
  goalTabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      var goal = this.getAttribute('data-goal');
      goalTabs.forEach(function(t){ t.classList.remove('active'); t.setAttribute('aria-selected','false'); });
      goalPanels.forEach(function(p){ p.classList.remove('active'); });
      this.classList.add('active');
      this.setAttribute('aria-selected','true');
      var panel = document.querySelector('.cdr-goal-panel[data-panel="'+goal+'"]');
      if(panel) panel.classList.add('active');
    });
  });

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.cdr-faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      var item = this.closest('.cdr-faq-item');
      var a = item.querySelector('.cdr-faq-a');
      var open = item.classList.contains('open');
      if(open){
        item.classList.remove('open');
        a.style.maxHeight = null;
        this.setAttribute('aria-expanded','false');
      } else {
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
        this.setAttribute('aria-expanded','true');
      }
    });
  });

/* ---- Sticky mobile CTA ---- */
  var stickyCta = document.getElementById('cdr-sticky');
  var supplySection = document.getElementById('supply');
  var heroSection = document.querySelector('.cd-hero-root') || document.querySelector('[class*="cd-hero"]');
  if(stickyCta && window.innerWidth <= 1024){
    var heroVisible = true, supplyVisible = false, endVisible = false;
    function updateSticky(){
      if(!heroVisible && !supplyVisible && !endVisible){ stickyCta.classList.add('is-visible'); }
      else { stickyCta.classList.remove('is-visible'); }
    }
    if(heroSection){
      new IntersectionObserver(function(entries){ heroVisible = entries[0].isIntersecting; updateSticky(); }, { threshold: 0.05 }).observe(heroSection);
    } else { heroVisible = false; }
    if(supplySection){
      new IntersectionObserver(function(entries){ supplyVisible = entries[0].isIntersecting; updateSticky(); }, { threshold: 0.1 }).observe(supplySection);
    }
    function armEndZones(){
      var zones = [].concat(
        Array.prototype.slice.call(document.querySelectorAll('.cdr-cta-banner')),
        Array.prototype.slice.call(document.querySelectorAll('footer, .optibio-footer'))
      ).filter(Boolean);
      if(!zones.length) return;
      var states = new Map();
      var endObs = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ states.set(e.target, e.isIntersecting); });
        endVisible = Array.from(states.values()).some(Boolean);
        updateSticky();
      }, { threshold: 0.05 });
      zones.forEach(function(z){ endObs.observe(z); });
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', armEndZones); }
    else { armEndZones(); }
  }

})();
}
